<script>
  import WidgetCard from '../components/WidgetCard.svelte';
  import ViewStateHistoryModal from '../modals/ViewStateHistoryModal.svelte';
  import CreateDeployment from './CreateDeployment.svelte';
  import Tooltip from '../reusable components/tooltip.svelte'
  import formatDate from '../Helpers/DateTimeFormatter'
  import { Card, CardBody, CardHeader, CustomInput, Table, Button, CardFooter, Pagination, PaginationLink, PaginationItem, Spinner } from 'sveltestrap';
  import { selectedGroup, currentPage } from '../store.js';
  import { onMount, onDestroy } from 'svelte';
  import http from '../api/http.js';
	import Search from '../components/Search.svelte';
  import TableColumn from '../components/TableColumn.svelte';
	import { get } from 'svelte/store';
	import prettysize from 'prettysize';
  
  const allFilterState = 'all';
  const transitionFilterState = 'transition';
  const requiresActionFilterState = 'requiresaction';
  const completedFilterState = 'complete';

  let createDeployment = false;
  let previousPageNumber = 0;
  let allDeploymentsSelected = false;
  let errorMessage = "";
  let filterState = 'all';
  let totalDeploymentCount = 0;
  let inProgressDeploymentCount = 0;
  let requiresActionDeploymentCount = 0;
  let completedDeploymentCount = 0;
  let includeCancelled = false;
  let isLoading = false;
  let searchRefresh = false;
  let inputLength = 0
  export let searchTerm = "";
  let pageNumber = 1;
  let totalPageCount = 0;
  let tableHeader = "All Deployments";
  let createDeploymentModal;
  let stateHistoryModal;
  let deployments = [];
  let selectedDeployments = [];
  let stateLegend = [
  {
    "name": "Pending",
    "value": "Awaiting user action.",
    "color": "warning"
  },
  {
    "name": "Deploying",
    "value": "Your deployment is being sent to the cloud.",
    "color": "info"
  },
  {
    "name": "Awaiting Collection",
    "value": "Your software is in the cloud waiting for the vessel to collect it.",
    "color": "info"
  },
  {
    "name": "Downloading",
    "value": "Your deployment is being downloaded by the vessel.",
    "color": "info"
  },
  {
    "name": "Cataloguing",
    "value": "The vessel is deserializing deployment contents.",
    "color": "info"
  },
  {
    "name": "Deployed",
    "value": "Your software has been deployed to the vessel.",
    "color": "success"
  },
  {
    "name": "Failed",
    "value": "Something went wrong when your software reached the vessel.",
    "color": "danger"
  },
  {
    "name": "Dispatch",
    "value": "Your deployment is being sent to dispatch.",
    "color": "info"
  }
];

const displayNumbers = [10, 25, 50, 100, 200];

let displayNumber = displayNumbers[0];

  let sortType = {
      ascending: 'ascending',
      descending: 'descending',
      resting: 'resting'
    }

  let activeColumn = {
    columnValue: 5,
    sortType: sortType.descending,
  };

  function toggleSort(columnValue, theSortType){
    if(activeColumn.value != columnValue){
      activeColumn.columnValue = columnValue;    
    }
    switch(theSortType){
      case sortType.resting:      
        activeColumn.sortType = sortType.ascending;      
        break;
      case sortType.ascending:
        activeColumn.sortType = sortType.descending;
        break;
      case sortType.descending:
        activeColumn.sortType = sortType.ascending;
        break;
    }
    
    if(activeColumn.sortType != sortType.resting){
      getDeployments(filterState, columnValue, activeColumn.sortType);
    }
    else{
      activeColumn.columnValue = 5;
      activeColumn.sortType = sortType.ascending;
      getDeployments(filterState, 5, activeColumn.sortType);
    }
  }

  $: {    
      $selectedGroup;
      if ($selectedGroup != undefined){
        pageNumber = 1;
        loadCountsAndDeployments();
      }  
    }

  $:activeColumn;

  $:{
    pageNumber;
    displayNumber;
    getDeployments(filterState, activeColumn.columnValue, activeColumn.sortType);
  }

  $: {
      if (previousPageNumber != pageNumber) {
      allDeploymentsSelected = false;
      previousPageNumber = pageNumber;
    }
  }

  $: {
    includeCancelled;
    loadWidgetCounts();
    getDeployments(filterState, activeColumn.columnValue, activeColumn.sortType);
  }

  async function loadCountsAndDeployments(){
    await loadWidgetCounts();
    await getDeployments(filterState, activeColumn.columnValue, activeColumn.sortType);
  }
  
  function setStatusColor(status){
    let color = "info";
    switch(status){
      case "Failed":
        color = "danger";
        break;

      case "Dispatch":
      case "Deploying":
      case "Awaiting Collection":
        color = "info";
        break;
        
      case "Pending":
        color = "warning";
        break;
      case "Deployed":
        color = "success";
        break;
    }
    return color;
  }

  function setPageNumber(number){
    pageNumber = number;    
  }

 function setFilter(filter){
      if(filter == allFilterState){
          tableHeader = "All Deployments";
          filterState = allFilterState;
      }
      else if(filter == transitionFilterState){
          tableHeader = "Deployments In Progress";
          filterState = transitionFilterState;
      }
      else if(filter == requiresActionFilterState){
          tableHeader = "Deployments Requiring Action";
          filterState = requiresActionFilterState;
      }
      else if(filter == completedFilterState){
          tableHeader = "Completed Deployments";
          filterState = completedFilterState;
      }
  }

  async function searchDeployments(){ 
    searchRefresh = true;
    let interval = setInterval( async () => {
      if(searchTerm.length != inputLength){
        pageNumber = 1;
        getDeployments(filterState, activeColumn.columnValue, activeColumn.sortType);   
      }
      if(!searchRefresh){
          clearInterval(interval);
      }
      inputLength = searchTerm.length;  
    }, 2000);    
  }

  async function getDeployments(deploymentState, columnValue, sortTypeArg){
    if(!isLoading){
      let ascending = sortTypeArg == sortType.ascending ? true : false;
      errorMessage = "";
      let url = "";
      if(columnValue == undefined){
          columnValue = 5;
      }
      if(ascending == undefined){
          ascending = true;
      }
      isLoading = true;
      if(searchTerm.length > 0 && searchTerm != ""){
        url = `/deploy/dashboard/deployments/${$selectedGroup}/${searchTerm}/${displayNumber}/${pageNumber}/${filterState}/${includeCancelled}/${columnValue}/${ascending}`;
      }
      else{
        url = `/deploy/dashboard/deployments/${$selectedGroup}/${displayNumber}/${pageNumber}/${deploymentState}/${includeCancelled}/${columnValue}/${ascending}`;
      }
      const res = await http.get(window.apiBaseUrl + url);
      if(res.status == 200){
        let uiDeploymentCollection = await res.json();
        deployments = uiDeploymentCollection.deployments;
        totalPageCount = uiDeploymentCollection.totalPageCount;
        isLoading = false;
        checkStoredDeployments();
      }
      else if(res.status == 404){
        isLoading = false;
        deployments = [];
      }
      else{
        errorMessage = "Something went wrong, please try again.";
        isLoading = false;
        deployments = [];
      }
    }
  }

  async function loadWidgetCounts(){
    const totalRes = await http.get(window.apiBaseUrl + `/deploy/dashboard/deployments/all/count/${$selectedGroup}/${includeCancelled}`);
    if(totalRes.status == 200){
      totalDeploymentCount = await totalRes.json();
    }
    const inProgressRes = await http.get(window.apiBaseUrl + `/deploy/dashboard/deployments/transition/count/${$selectedGroup}/${includeCancelled}`);
    if(inProgressRes.status == 200){
      inProgressDeploymentCount = await inProgressRes.json();
    }
    const failedRes = await http.get(window.apiBaseUrl + `/deploy/dashboard/deployments/requiresaction/count/${$selectedGroup}/${includeCancelled}`);
    if(failedRes.status == 200){
      requiresActionDeploymentCount = await failedRes.json();
    }
    const completedRes = await http.get(window.apiBaseUrl + `/deploy/dashboard/deployments/complete/count/${$selectedGroup}/${includeCancelled}`);
    if(completedRes.status == 200){
      completedDeploymentCount = await completedRes.json();
    }
  }

  async function triggerDeployments(){
    errorMessage = "";
    isLoading = true;
    const res = await http.put(window.apiBaseUrl + `/deploy/dashboard/deployments/trigger/pending/${$selectedGroup}`, selectedDeployments);
    selectedDeployments.forEach((deployment) => {
      deployment.selected = false;
    })
    deployments = deployments;
    selectedDeployments = [];
    if(res.status != 200){
       errorMessage = "Something went wrong, please try again.";
    }
    else{
      errorMessage = "";
    }
    isLoading = false;
  }

  async function cancelDeployment(deployment){
    let deplpoyments  = [];
    deplpoyments.push(deployment);
    const res = await http.delete(window.apiBaseUrl + `/deploy/dashboard/deployments/${$selectedGroup}`, deplpoyments);
    if(res.status == 200){
      getDeployments(filterState, activeColumn.columnValue, activeColumn.sortType);
      errorMessage = "";
    }
    else{
      errorMessage = "Something went wrong cancelling the deployment, please try again.";
    }
  }

  function selectDeployment(deployment){
    if(deployment.selected){
      selectedDeployments.push(deployment);
    }
    else{
      selectedDeployments = selectedDeployments.filter(d => d.id != deployment.id);
    }
    selectedDeployments = selectedDeployments;
    deployments = deployments;
  }

  function selectAllDeployments(){
    if(allDeploymentsSelected){
      deployments.forEach(deployment => {
        deployment.selected = true;
        if(!selectedDeployments.map(d => d.id).includes(deployment.id) && deployment.status.toLocaleLowerCase() == "pending"){
          selectedDeployments.push(deployment);
        }
      });
    }
    else{
        deployments.forEach(deployment => {
        deployment.selected = false;
        selectedDeployments = selectedDeployments.filter(d => d.id != deployment.id);
      });
    }
    deployments = deployments;
    selectedDeployments = selectedDeployments;
  }

  function checkStoredDeployments() {
    deployments.forEach(deployment => {
      if (selectedDeployments.map(d => d.id).includes(deployment.id)) {
        deployment.selected = true;
      }
    });
  }
  
   const interval = setInterval(loadCountsAndDeployments, 30000);
 
   onMount(async () => {      
    currentPage.set('deployments');
  });

  onDestroy(() => clearInterval(interval));
</script>
{#if createDeployment == false}
  <div class="d-flex">
    <h4 class="font-weight-bold text-primary mb-0">Deployments</h4>
    <div class="ml-auto">
      <CustomInput type="switch" on:change={() => includeCancelled = includeCancelled == false ? true : false} id="toggleIncludeCancelled" label="Show Cancelled Deployments" checked={includeCancelled == true}></CustomInput>
    </div>
  </div>
<p class="text-danger">{errorMessage}</p>
  <div class="grid" id="grid">
      <WidgetCard id="total-deployments-widget" title="All Deployments" value="{totalDeploymentCount}" icon="paper-plane" color="info" withFooter=true on:mousedown={() => setFilter(allFilterState)} active={filterState == allFilterState} disabled={isLoading}>
        <p slot="footer" class="ml-auto">View</p>
      </WidgetCard>
      <WidgetCard id="in-progress-deployments-widget" title="In Progress" value="{inProgressDeploymentCount}" icon="clock" color="warning" withFooter=true on:mousedown={() => setFilter(transitionFilterState)} active={filterState == transitionFilterState} disabled={isLoading}>
        <p slot="footer" class="ml-auto">View</p>
      </WidgetCard>
      <WidgetCard id="requiring-action-deployments-widget" title="Requiring Action" value="{requiresActionDeploymentCount}" icon="exclamation" color="danger" withFooter=true on:mousedown={() => setFilter(requiresActionFilterState)} active={filterState == requiresActionFilterState} disabled={isLoading}>
        <p slot="footer" class="ml-auto">View</p>
      </WidgetCard>
      <WidgetCard id="complete-deployments-widget" title="Completed" value="{completedDeploymentCount}" icon="check" color="success" withFooter=true on:mousedown={() => setFilter(completedFilterState)} hasBackgroundColor="true" backgroundColor="bg-success" className="success" active={filterState == completedFilterState} disabled={isLoading}>
        <p slot="footer" class="ml-auto">View</p>
      </WidgetCard>
  </div>
<Card>
  <CardHeader>
    <div class="row">
        <div class="col-sm">
            <h6 class="font-weight-bold mt-2 mb-2">{tableHeader}</h6>
        </div>
        {#if isLoading}
          <Spinner color="primary" type="border"></Spinner>
        {/if}
         <div class="col-sm">
            <Search id="deployments-search-input" bind:searchTerm placeholder="Search Deployments..." on:input={() => searchDeployments()}></Search>   
         </div>
        <div class="col-sm">
            <Button id="create-deployment-button" color="primary" class="btn-plus btn-icon-split float-right ml-2" on:click={() => createDeployment = !createDeployment}>
                <span class="icon">
                  <i class="fas fa-plus" style="vertical-align:auto !important;"></i>
                </span>
              <span class="text">
                  Create New            
                </span>
            </Button>
            <Button id="deploy-selected-button" on:click={() => triggerDeployments()} color="primary" class="btn-plus btn-icon-split float-right" disabled={selectedDeployments.length == 0}>
                <span class="icon">
                  <i class="fas fa-paper-plane" style="vertical-align:auto !important;"></i>
                </span>
                <span class="text">
                    Deploy Selected   
                </span>
            </Button>    
        </div>
      </div>
    </CardHeader>
  <CardBody>
    {#if deployments.length == 0}
      <p>No deployments to display.</p>
    {:else}
      <Table responsive>
        <thead>
          <th><input class="mr-2" type="checkbox" bind:checked={allDeploymentsSelected} on:change={() => selectAllDeployments()} id="select-all-deployments">{selectedDeployments.length > 0 ? `(${selectedDeployments.length})` : ""}</th>
          <TableColumn on:mousedown={() => toggleSort(0, activeColumn.sortType)} active={activeColumn.columnValue == 0} sortType={activeColumn.sortType}>Vessel Name</TableColumn>
          <TableColumn on:mousedown={() => toggleSort(1, activeColumn.sortType)} active={activeColumn.columnValue == 1} sortType={activeColumn.sortType}>Package Name</TableColumn>
          <TableColumn on:mousedown={() => toggleSort(2, activeColumn.sortType)} active={activeColumn.columnValue == 2} sortType={activeColumn.sortType}>Package Version</TableColumn>
          <TableColumn on:mousedown={() => toggleSort(3, activeColumn.sortType)} active={activeColumn.columnValue == 3} sortType={activeColumn.sortType}>Package Type</TableColumn>
          <TableColumn on:mousedown={() => toggleSort(4, activeColumn.sortType)} active={activeColumn.columnValue == 4} sortType={activeColumn.sortType}>Status <Tooltip content={stateLegend} legend={true} title={"Deployment Status"}> <i class="fad fa-question-circle fa-sm font-weight-normal"></i></Tooltip></TableColumn>
          <TableColumn on:mousedown={() => toggleSort(5, activeColumn.sortType)} active={activeColumn.columnValue == 5} sortType={activeColumn.sortType}>Last Updated</TableColumn>
          <TableColumn on:mousedown={() => toggleSort(6, activeColumn.sortType)} active={activeColumn.columnValue == 6} sortType={activeColumn.sortType}>Triggered By</TableColumn>
          <th>Actions</th>
        </thead>
        <tbody>
          {#each deployments as deployment}
            <tr id="deployment-row-{deployment.id}">
              {#if deployment.status.toLocaleLowerCase() == "pending"}
                <td><input id="deployment-checkbox-{deployment.id}" type="checkbox" bind:checked={deployment.selected}  on:change={() => selectDeployment(deployment)}/></td>
                {:else}
                <td></td>
              {/if}
              <td>{deployment.vesselName}</td>  
              <td>{deployment.packgeVersionName}</td>
              <td>{deployment.softwareVersionNumber}</td>
              <td>{deployment.packageType}</td>
              <td>
                <strong class="text-{setStatusColor(deployment.status)}">
                  {deployment.status} 
                  {#if deployment.status.toLocaleLowerCase() == "downloading"}
                    {deployment.downloadPercentage}
                    <br>
                    {prettysize(deployment.downloadProgress)}&nbsp;/&nbsp;{prettysize(deployment.downloadPacketSize)}
                  {/if}
                </strong>
              </td>
              <td>{formatDate(deployment.lastUpdated)}</td>
              <td>{deployment.triggeredBy}</td>
              <td>
                <Button id="view-deployment-history-{deployment.id}" on:click={() => stateHistoryModal.show(deployment.id, "Deployment")} color="primary" class="btn-plus btn-icon-split btn-sm" alt="View rule" title="View">
                  <span class="icon text-white-50">
                      <i class="fas fa-eye"style="vertical-align:auto !important;"></i>
                  </span>
                </Button>
                {#if deployment.status.toLocaleLowerCase() == "pending" }
                  <Button id="cancel-deployment-{deployment.id}" on:click={() => cancelDeployment(deployment)} color="primary" class="btn-plus btn-icon-split btn-sm" alt="Cancel deployment" title="Cancel">
                    <span class="icon text-white-50">
                        <i class="fas fa-times"style="vertical-align:auto !important;"></i>
                    </span>
                  </Button>
                {/if} 
              </td>
            </tr>
            {:else}
            <tr>
              <td colspan="7" class="text-center">No Deployments Found</td>
            </tr>
          {/each}
        </tbody>
      </Table>
    {/if}    
  </CardBody>
  <CardFooter>
    <div class="pagination bg-light shadow-none ml-0 d-flex">
      {#if deployments.length == 0}
        <small class="mt-3 mr-auto">0 - 0 of 0 deployments</small>
      {:else}
        {#if searchTerm.length > 0 && searchTerm != ""}
        <small class="mt-3 mr-auto">{pageNumber == 1 ? 1:(pageNumber - 1) * displayNumber + 1} - {(pageNumber * displayNumber > deployments.length ? deployments.length:pageNumber * displayNumber)} of {deployments.length} deployments</small>
        {:else}
          <small class="mt-3 mr-auto">{pageNumber == 1 ? 1:(pageNumber - 1) * displayNumber + 1} - {(pageNumber * displayNumber > totalDeploymentCount ? totalDeploymentCount:pageNumber * displayNumber)} of {totalDeploymentCount} deployments</small>
        {/if}
      {/if}      
      
      <div class="mt-2 justify-content-center">
         <Pagination>
            <PaginationItem disabled={pageNumber == 1}>
              <PaginationLink id="pagination-first-page-button" first on:click={() => pageNumber = 1} href="#"/>
            </PaginationItem>

            <PaginationItem  disabled={pageNumber == 1}>
              <PaginationLink id="pagination-previous-page-button" previous on:click={() => setPageNumber(pageNumber - 1)} href="#" />
            </PaginationItem>

            {#if totalPageCount > 5}
              {#each Array(5) as _, count}
                {#if pageNumber > 3 && pageNumber < totalPageCount - 2}
                  <PaginationItem active={pageNumber == count + pageNumber} >
                    <PaginationLink id="pagination-page-{pageNumber + count}-button" on:click={() => setPageNumber(pageNumber + count)} href="#">{pageNumber + count}</PaginationLink>
                  </PaginationItem>
                {:else if pageNumber <= 3}
                  <PaginationItem active={pageNumber == count + 1} >
                    <PaginationLink id="pagination-page-{count + 1}-button" on:click={() => setPageNumber(count + 1)} href="#">{count + 1}</PaginationLink>
                  </PaginationItem>
                {:else if pageNumber >= totalPageCount - 2}
                  <PaginationItem active={pageNumber == totalPageCount - 4 + count} >
                    <PaginationLink id="pagination-page-{totalPageCount - 4 + count}-button" on:click={() => setPageNumber(totalPageCount - 4 + count)} href="#">{totalPageCount - 4 + count}</PaginationLink>
                  </PaginationItem>
                {/if}
              {/each}
            {:else}
              {#each Array(totalPageCount) as _, count}
                <PaginationItem active={pageNumber == count + 1} on:click={() => pageNumber == count + 1}>
                  <PaginationLink id="pagination-page-{count + 1}-button" on:click={() => setPageNumber(count + 1)} href="#">{count + 1}</PaginationLink>
                </PaginationItem>
              {/each}
            {/if}      

            <PaginationItem disabled={pageNumber == totalPageCount}>
              <PaginationLink id="pagination-next-page-button" next href="#" on:click={() => setPageNumber(pageNumber + 1)} />
            </PaginationItem>
            
            <PaginationItem disabled={pageNumber == totalPageCount}>
              <PaginationLink id="pagination-last-page-button" last href="#" on:click={() => setPageNumber(totalPageCount)}/>
            </PaginationItem>
          </Pagination>
      </div>
      <div class="mt-3 ml-auto">
        <select class="form-select" id="displayNumberSelect" bind:value={displayNumber}>
          {#each displayNumbers as displayNumber}
            <option value={displayNumber}>{displayNumber}</option>
          {/each}
        </select>
        <label class="ml-1" id="displayNumberLabel" for="displayNumberSelect">Per page</label>     
      </div>  
    </div>
  </CardFooter>
</Card>

<ViewStateHistoryModal bind:this={stateHistoryModal}></ViewStateHistoryModal>

{:else}
  <CreateDeployment bind:visible={createDeployment} on:deploymentCreated={() => loadCountsAndDeployments()}/>
{/if}
<style>  
  #displayNumberSelect{
    max-height: 30px;
    background-color: white;
    border-radius: 6px;
    border: 1px solid #DEDEDE;
    height:400px;
    color:#3a3a3a;
  }

  p{
    font-size: 0.8em;
  }

  select{
    background-color: white;
    border: 1px solid #ced4da;
    border-radius: 0.25rem;
  }

    .grid {
      grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
      display: grid;
      gap: 1em;
      margin-top: 1.5em;
      margin-bottom: 1.5em;
  }
    .grid div {
       padding: 4px;
    }

    .toggle{
    cursor: pointer;
  }

</style>

